/**
 * Created by AlexanderC on 3/7/16.
 */

'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HttpDriver = undefined;

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _AbstractDriver2 = require('./AbstractDriver');

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

let HttpDriver = exports.HttpDriver = function (_AbstractDriver) {
  _inherits(HttpDriver, _AbstractDriver);

  /**
   * @param {String} endpoint
   * @param {Boolean} enforceRoot
   */
  function HttpDriver() {
    let endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    let enforceRoot = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

    _classCallCheck(this, HttpDriver);

    var _this = _possibleConstructorReturn(this, (HttpDriver.__proto__ || Object.getPrototypeOf(HttpDriver)).call(this));

    _this._endpoint = endpoint;
    _this._enforceRoot = enforceRoot;
    return _this;
  }

  /**
   * @returns {String|*}
   */


  _createClass(HttpDriver, [{
    key: 'setEndpoint',


    /**
     * @param {String} endpoint
     * @returns {HttpDriver}
     */
    value: function setEndpoint(endpoint) {
      this._endpoint = endpoint;

      return this;
    }

    /**
     * @param {String} endpoint
     * @private
     */

  }, {
    key: '_load',
    value: function _load() {
      let endpoint = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;

      this._endpoint = endpoint || this._endpoint;

      if (this._enforceRoot && !/^http|\//i.test(this._endpoint)) {
        this._endpoint = `/${this._endpoint}`;
      }

      let client = new XMLHttpRequest();

      client.open('GET', this._endpoint);

      client.onreadystatechange = () => {
        if (client.readyState === 4) {
          if (client.status !== 200) {
            this.fail(`Failed to load config from ${this._endpoint} (status=${client.status})`);
          } else {
            this.loadedJson(client.responseText);
          }
        }
      };

      client.send();
    }
  }, {
    key: 'endpoint',
    get: function get() {
      return this._endpoint;
    }
  }]);

  return HttpDriver;
}(_AbstractDriver2.AbstractDriver);


//////////////////
// WEBPACK FOOTER
// ../~/deep-kernel/lib.compiled/Config/Driver/HttpDriver.js
// module id = 173
// module chunks = 0